import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { nanoid } from 'nanoid';

export interface SavedBudget {
  id: string;
  name: string;
  createdAt: string;
  income: number;
  selectedState: string;
  filingStatus: 'single' | 'joint' | 'head';
  period: 'weekly' | 'biweekly' | 'semimonthly' | 'monthly' | 'yearly';
  expenses: Array<{
    id: string;
    name: string;
    amount: number;
    category: 'needs' | 'wants' | 'savings';
  }>;
}

interface BudgetState {
  savedBudgets: SavedBudget[];
  saveBudget: (budget: Omit<SavedBudget, 'id' | 'createdAt'>) => void;
  deleteBudget: (id: string) => void;
  updateBudget: (id: string, updates: Partial<Omit<SavedBudget, 'id'>>) => void;
  getBudget: (id: string) => SavedBudget | undefined;
}

export const useBudgetStore = create<BudgetState>()(
  persist(
    (set, get) => ({
      savedBudgets: [],
      
      saveBudget: (budget) => set((state) => ({
        savedBudgets: [
          {
            ...budget,
            id: nanoid(),
            createdAt: new Date().toISOString()
          },
          ...state.savedBudgets
        ]
      })),
      
      deleteBudget: (id) => set((state) => ({
        savedBudgets: state.savedBudgets.filter(budget => budget.id !== id)
      })),
      
      updateBudget: (id, updates) => set((state) => ({
        savedBudgets: state.savedBudgets.map(budget =>
          budget.id === id ? { ...budget, ...updates } : budget
        )
      })),
      
      getBudget: (id) => get().savedBudgets.find(budget => budget.id === id)
    }),
    {
      name: 'budget-storage'
    }
  )
);